import { CellData } from '@ddt-web/data-service';
import { RowNode } from 'ag-grid-community';

import { StatusColour } from '../models';

export class FundAnalysisColumnSortingUtil {

	public static defaultColumnComparator(valueA: CellData, valueB: CellData, nodeA: RowNode, nodeB: RowNode, isInverted: boolean): number {
		if (
			// Keep Morningstar categories where they are
			(nodeA.data.isMorningstarCategory?.rawValue || nodeB.data.isMorningstarCategory?.rawValue) ||
			// Don't let funds move between morningstar categories
			(nodeA.data.morningstarCategory?.formattedValue !== nodeB.data.morningstarCategory?.formattedValue)
		) {
			return 0;
		}

		// Comparison logic for funds in each category
		// Case insensitive sorting as lower case letters > upper case letters
		// Important for iShares
		let rawValueA = valueA?.rawValue;
		let rawValueB = valueB?.rawValue;
		if (typeof rawValueA === 'string' && typeof rawValueB === 'string') {
			rawValueA = rawValueA.toUpperCase();
			rawValueB = rawValueB.toUpperCase();
		}

		if (rawValueA === rawValueB) {
			return 0;
		} else if (rawValueA > rawValueB) {
			return 1;
		} else {
			return -1;
		}
	}

	public static statusColumnComparator(valueA: CellData, valueB: CellData, nodeA: RowNode, nodeB: RowNode, isInverted: boolean): number {
		if (
			// Keep Morningstar categories where they are
			(nodeA.data.isMorningstarCategory?.rawValue || nodeB.data.isMorningstarCategory?.rawValue) ||
			// Don't let funds move between morningstar categories
			(nodeA.data.morningstarCategory?.formattedValue !== nodeB.data.morningstarCategory?.formattedValue)
		) {
			return 0;
		}

		const aIsSuggestedAddition = valueA?.attribute?.fundIdea?.isSuggestedAddition;
		const bIsSuggestedAddition = valueB?.attribute?.fundIdea?.isSuggestedAddition;

		// Suggested additions show up last in the category
		if (aIsSuggestedAddition === bIsSuggestedAddition) {
			return FundAnalysisColumnSortingUtil.compareStatuses(valueA, valueB);
		} else if (aIsSuggestedAddition && !bIsSuggestedAddition) {
			return 1;
		} else if (!aIsSuggestedAddition && bIsSuggestedAddition) {
			return -1;
		}

		// Comparison logic for funds in the analysis
		return FundAnalysisColumnSortingUtil.compareStatuses(valueA, valueB);
	}

	private static compareStatuses(valueA: CellData, valueB: CellData): number {
		if (valueA?.formattedValue === valueB?.formattedValue) {
			return 0;
		} else if (valueB?.formattedValue === StatusColour.RED.colour) {
			return 1;
		} else if (valueA?.formattedValue === StatusColour.RED.colour) {
			return -1;
		} else if (valueB?.formattedValue === StatusColour.GREEN.colour) {
			return -1;
		} else if (valueB?.formattedValue === StatusColour.YELLOW.colour && valueA?.formattedValue === StatusColour.RED.colour) {
			return -1;
		} else if (valueB?.formattedValue === StatusColour.YELLOW.colour && valueA?.formattedValue === StatusColour.GREEN.colour) {
			return 1;
		}
		return 0;

	}
}
